import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { helpers } from "../../../../common/lib";

export default (auditId: number) => {
    const { audits } = useSelector((state) => state);

    return useMemo(() => {
        const { branch } = helpers.getListItemForId(audits, auditId);
        return branch ? branch.name : "";
    }, [auditId, audits]);
};
